import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import StateField from './state-field';
import SchoolField from './school-field';
import FormProcessing from './form-processing';
import Button from './button';
import FormError from './form-error';
import { useAuth } from '../contexts/AuthContext';
import GradeBandField from './grade-band-field';

function SignUpRequirementsPasswordUser({ scrollToTop }) {
  const [state, setState] = useState('');
  const [schoolId, setSchoolId] = useState('');
  const [gradeBand, setGradeBand] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState('');
  const { profile, getSchoolFromId, signUpAdditionalData, signOut } = useAuth();

  async function handleFormSubmit(event) {
    event.preventDefault();

    if (!isProcessing) {
      if (profile.coppaAge && !state) {
        setError('Please select a state.');
        scrollToTop();
      } else if (profile.coppaAge && !schoolId) {
        setError('Please select a school.');
        scrollToTop();
      } else {
        setIsProcessing(true);
        setError('');

        const data = {
          state,
          completedProfile: true,
          gradeBand,
        };

        if (profile.coppaAge) {
          try {
            data.schoolData = await getSchoolFromId(schoolId.value);
          } catch (err) {
            // error silently
          }
        }

        try {
          await signUpAdditionalData(data);
        } catch (err) {
          setError(err.message);
          setIsProcessing(false);
          scrollToTop();
        }
      }
    }
  }

  return (
    <div>
      <FormError message={error} />
      <form onSubmit={handleFormSubmit}>
        {profile.coppaAge && (
          <div className={classNames('form-group')}>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className={classNames('form-label')}>
              State*
              <StateField onChange={(value) => setState(value)} value={state} />
            </label>
          </div>
        )}
        {profile.coppaAge && (
          <div className={classNames('form-group')}>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="schoolList" className={classNames('form-label')}>
              School Name*
            </label>
            <SchoolField onChange={(e) => setSchoolId(e)} state={state} />
            {profile.roles.indexOf('parent') >= 0 && (
              <div className="form-helper">Parent / Caregiver, choose the school your child attends.</div>
            )}
          </div>
        )}
        {profile.coppaAge && (
          <div className={classNames('form-group')}>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className={classNames('form-label')}>Grade*
              <GradeBandField setGradeBand={(gb) => setGradeBand(gb)} />
              {(profile.roles.indexOf('teacher') >= 0 || profile.roles.indexOf('parent') >= 0) && (
                <div className="form-helper">
                  Grownups, select the grade band that best describes your student(s).
                </div>
              )}
            </label>
          </div>
        )}
        <div className={classNames('form-actions')}>
          <FormProcessing isProcessing={isProcessing}>
            <Button size="md" type="submit" theme="blue" width="md">
              Finish Sign Up
            </Button>
            <Button size="md" theme="transparent" type="button" width="md" action={signOut}>
              Sign out
            </Button>
          </FormProcessing>
        </div>
      </form>
    </div>
  );
}

SignUpRequirementsPasswordUser.propTypes = {
  scrollToTop: PropTypes.func.isRequired,
};

export default SignUpRequirementsPasswordUser;
